import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { IntlContext } from '@/contexts/intlContext';

const LanguageSwitch = () => {
  const router = useRouter();
  const { switchLang } = useContext(IntlContext);

  return (
    <div className="flex text-20">
      <Link href={`${router.asPath}`} locale="fr">
        <a className="w-3 mr-1" onClick={() => switchLang('fr')}>
          <img src="/img/lang/fr.svg" alt="Flag french" height={16} width={24} />
        </a>
      </Link>
      <Link href={router.pathname === '/[...strapi]' ? `/` : `${router.asPath}`} locale="en">
        <a className="w-3 mr-1" onClick={() => switchLang('en')}>
          <img src="/img/lang/usa.svg" alt="Flag USA" height={16} width={24} />
        </a>
      </Link>
      <Link href={router.pathname === '/[...strapi]' ? `/` : `${router.asPath}`} locale="de">
        <a className="w-3" onClick={() => switchLang('de')}>
          <img src="/img/lang/de.svg" alt="Flag Germany" height={16} width={24} />
        </a>
      </Link>
    </div>
  );
};

export default LanguageSwitch;
